import './BillingModalHeader.pcss';
import React from 'react';
import { EnhancedPlan, PlanTypeBE } from '@mm/state/interfaces/subscription';
import { EnhancedBillingPage } from '@mm/state/interfaces/connected-page';
import CompanyModel from '@mm/state/model/CompanyModel';

type Props = {
  facebookPage?: EnhancedBillingPage;
  plan: EnhancedPlan;
  company?: CompanyModel;
};

const BillingModalHeader = ({ facebookPage, plan, company }: Props) => (
  <div className="billing-modal-header">
    {plan.planType === PlanTypeBE.team && company && (
      <div className="billing-modal-header__company-name">
        Company: <strong>{company.name}</strong>
      </div>
    )}
    {plan.planType !== PlanTypeBE.team && (
      <div className="billing-modal-header__facebook-page-name">
        {facebookPage?.name}
      </div>
    )}
    <div className="billing-modal-header__plan-name">{plan.shortName} Plan</div>
  </div>
);

export { BillingModalHeader };
